/*
    公共方法
*/

import Vue from "vue";
import axios from "axios";
import { Message } from "element-ui"
import { format } from "date-fns"
const env = process.env.API_ENV
class Common {
  guidGenerator () {
    let S4 = () => {
      return (((1 + Math.random()) * 0x10000) | 0)
        .toString(16)
        .substring(1);
    };
    return "a" + S4() + "_" + S4() + "_" + S4() + "_" + S4();
  }
  getData (_url, _params, _method, _timeout) {
    return axios({
      method: _method,
      url: _url,
      params: _params, // Query string parameters
      data: _params, // request payload
      // responseType: "json",
      timeout: _timeout || 20000
    });
  }
  axiosHttpRequest(url, params, method, exportFlag, timeout){
    const _method = method.toLowerCase()
    return axios({
      method,
      url,
      params: _method === "get" ?  params : {}, // Query string parameters
      data: _method === "post" ? params : {}, // request payload
      exportFlag,
      responseType: exportFlag && "blob",
      timeout: timeout || 20000
    });
  }
  //导出用户下载文件流
 exDownloadFileStream(fileStream, name, callback) {
    const blob = new Blob([fileStream])
    const link = document.createElement("a")
    link.href = URL.createObjectURL(blob)
    link.download = `${name || format(new Date(), "yyyy-MM-dd")}.xls`
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    if(callback) callback()
  }
  compareDate (str1, str2) {
    let time1 = new Date(str1).getTime();
    let time2 = new Date(str2).getTime();
    return time1 <= time2;
  }
  formatDate (val, type) {
    let date = new Date(val);
    let month = date.getMonth() + 1;
    if (month < 10) {
      month = "0" + month;
    }
    let day = date.getDate();
    if (day < 10) {
      day = "0" + day;
    }
    let hour = date.getHours();
    if (hour < 10) {
      hour = "0" + hour;
    }
    let min = date.getMinutes();
    if (min < 10) {
      min = "0" + min;
    }
    let sec = date.getSeconds();
    if (sec < 10) {
      sec = "0" + sec;
    }
    const actions = new Map([
      [
        "yyyy",
        {
          date: date.getFullYear()
        }
      ],
      [
        "yyyy-MM",
        {
          date: date.getFullYear() + "-" + month
        }
      ],
      [
        "yyyy-MM-dd",
        {
          date: date.getFullYear() + "-" + month + "-" + day
        }
      ],
      [
        "yyyy-MM-dd HH",
        {
          date:
            date.getFullYear() +
            "-" +
            month +
            "-" +
            day +
            " " +
            hour
        }
      ],
      [
        "yyyy-MM-dd HH:mm",
        {
          date:
            date.getFullYear() +
            "-" +
            month +
            "-" +
            day +
            " " +
            hour +
            ":" +
            min
        }
      ],
      [
        "yyyy-MM-dd HH:mm:ss",
        {
          date:
            date.getFullYear() +
            "-" +
            month +
            "-" +
            day +
            " " +
            hour +
            ":" +
            min +
            ":" +
            sec
        }
      ]
    ]);
    let action = actions.get(type);
    return action.date;
  }
  getParamsFromURL (str, key) {
    let index = str.indexOf("?");
    let urlStr = str.substr(index * 1 + 1);
    let paramsList = urlStr.split("&");
    let value = "";
    for (let list of paramsList) {
      if (list) {
        let arr = list.split("=");
        if (arr.length) {
          if (arr[0] == key) {
            value = arr[1];
            break;
          }
        }
      }
    }
    return value;
  }
  isPC () {
    let userAgentInfo = navigator.userAgent;
    let Agents = [
      "Android",
      "iPhone",
      "SymbianOS",
      "Windows Phone",
      "iPad",
      "iPod"
    ];
    let flag = true;
    flag = Agents.every(item => {
      return !userAgentInfo.includes(item);
    });
    return flag;
  }
  judgeBrower () {
    const userAgent = navigator.userAgent;
    if (userAgent.includes("Chrome")) {
      return "Chrome";
    } else if (userAgent.includes("Firefox")) {
      return "Firefox";
    } else if (userAgent.includes("Safari")) {
      return "Safari";
    } else if (userAgent.includes("Opera")) {
      return "Opera";
    } else {
      return "IE";
    }
  }
  setCookie (name, value, time) {
    let Days = time || 1;
    //var strsec = getsec(time);
    let exp = new Date();
    const domain = location.hostname
    exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000);
    document.cookie =
      name + "=" + escape(value) + ";expires=" + exp.toGMTString() + `domain=${domain}` + ";path=/";
  }
  getsec (str) {
    let str1 = str.substring(1, str.length) * 1;
    let str2 = str.substring(0, 1);
    if (str2 == "s") {
      return str1 * 1000;
    } else if (str2 == "h") {
      return str1 * 60 * 60 * 1000;
    } else if (str2 == "d") {
      return str1 * 24 * 60 * 60 * 1000;
    }
  }
  getCookie (name) {
    let arr;
    let reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
    if ((arr = document.cookie.match(reg))) return unescape(arr[2]);
    else return null;
  }
  delCookie (name) {
    let exp = new Date();
    exp.setTime(exp.getTime() - 1);
    let cval = this.getCookie(name);
    if (cval != null) {
      document.cookie =
        name + "=" + cval + ";expires=" + exp.toGMTString();
    }
  }
  linkUrl (url, params) {
    let arr = []
    for (let i in params) {
      arr.push(`${i}=${params[i]}`)
    }
    if (url.indexOf("?") > -1) {
      return url + "&" + arr.join("&") + '&t=' + (+new Date())
    } else {
      return url + "?" + arr.join("&") + '&t=' + (+new Date())
    }
  }
  message (option) {
    Message.closeAll()
    Message(option)
  }
  tree (arr) {
    let source = arr
    source.map((i, index) => {
      if (i.next && i.next.length == 0) {
        source.splice(index, 1)
      } else if (i.next && i.next.length > 0) {
        let _tree = this.tree(i.next)
        if (!_tree.length) {
          source.splice(index, 1)
        } else {
          source[index].next = this.tree(i.next)
        }
      }
    })
    return source
  }
  // 11位手机号
  checkPhoneNumber(tel){
    const reg = /^[1][3,4,5,7,8,9][0-9]{9}$/;
    if(!reg.test(tel)) return false
    return true
  }

  // 防抖
  debounce(fn, wait = 1000){
    let timer = null
    return function (){
      const _this = this
      let args = arguments
      if(timer) clearTimeout(timer)
      timer = setTimeout(function () {
        fn.apply(_this, args)
      }, wait)
    }
  }
}

let common = new Common();
export default common;



// WEBPACK FOOTER //
// ./src/utils/common/common.js